/* Note lane dialogs (W2-03). Tokens only. */

.body {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}

.scope {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

.lineList {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  max-height: 180px;
  padding: var(--space-2);
  overflow-y: auto;
  border: var(--border-width) solid var(--color-border);
  border-radius: var(--radius-sm);
  background: var(--color-surface-2);
}
